import React from 'react';
import { staticImageAssets } from 'js/constants/Paths';

const AnimationClouds = ({ active = false }) => {
  return (
    <div className={'animation__clouds' + (active ? ' animation__clouds--active' : '')}>
      <div className="animation__clouds__cloud-1">
        <img src={staticImageAssets('images/static/cloud_1.png')} />
      </div>
      <div className="animation__clouds__cloud-2">
        <img src={staticImageAssets('images/static/cloud_2.png')} />
      </div>
    </div>
  );
};
export default AnimationClouds;
